import { normalizeGuestName } from "./name-validation";

const GENERIC_LINK_ERROR = "Este enlace no es válido, expiró o ya fue utilizado.";

export function renderLoading(container: HTMLElement, message: string): void {
  container.innerHTML = "";
  const wrapper = document.createElement("div");
  wrapper.className = "meet-screen";
  wrapper.innerHTML = `
    <div class="spinner" role="status" aria-label="Cargando"></div>
    <p>${message}</p>
  `;
  container.appendChild(wrapper);
}

export function renderError(container: HTMLElement, message: string = GENERIC_LINK_ERROR): void {
  container.innerHTML = "";
  const wrapper = document.createElement("div");
  wrapper.className = "meet-screen";
  wrapper.innerHTML = `
    <h1>No se pudo unir a la reunión</h1>
    <p>${message}</p>
  `;
  container.appendChild(wrapper);
}

/**
 * Meet/Zoom-style name-capture screen for the anonymous guest path
 * (issue #6). Renders a minimal form; `onSubmit` is only invoked once the
 * entered name passes the empty/whitespace-only guard.
 */
export function renderNameForm(container: HTMLElement, onSubmit: (name: string) => void): void {
  container.innerHTML = "";
  const wrapper = document.createElement("div");
  wrapper.className = "meet-screen";
  wrapper.innerHTML = `
    <h1>Ingresá tu nombre para unirte</h1>
    <form class="name-form" novalidate>
      <input type="text" name="guestName" placeholder="Tu nombre" autocomplete="name" />
      <p class="name-form-error" role="alert" hidden></p>
      <button type="submit">Unirse</button>
    </form>
  `;
  container.appendChild(wrapper);

  const form = wrapper.querySelector("form") as HTMLFormElement;
  const input = wrapper.querySelector("input[name='guestName']") as HTMLInputElement;
  const errorEl = wrapper.querySelector(".name-form-error") as HTMLParagraphElement;

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const name = normalizeGuestName(input.value);
    if (!name) {
      errorEl.textContent = "Ingresá un nombre para continuar.";
      errorEl.hidden = false;
      input.focus();
      return;
    }
    errorEl.hidden = true;
    onSubmit(name);
  });

  input.focus();
}

export { GENERIC_LINK_ERROR };
